export interface Metric {
	value: number;
	suffix: string;
	decimals?: number;
	label: string;
	sublabel: string;
}

export const metrics: Metric[] = [
	{
		value: 90,
		suffix: 's',
		label: 'Global fleet rollout time',
		sublabel: 'Atomic OTA, 10k devices'
	},
	{
		value: 10,
		suffix: 'M+',
		label: 'Device scale ceiling',
		sublabel: 'Per-tenant architecture'
	},
	{
		value: 99.99,
		suffix: '%',
		decimals: 2,
		label: 'Target platform SLA',
		sublabel: 'Multi-region redundancy'
	},
	{
		value: 60,
		suffix: 's',
		label: 'From power-on to online',
		sublabel: 'Zero-touch provisioning'
	}
];
